import * as React from 'react';
import { useSelector } from 'react-redux';
import {
    DashboardMenuItem,
    Menu as RaMenu,
    MenuProps,
    MenuItemLink,
    getResources,
    usePermissions,
    useGetIdentity
} from 'react-admin';
import DefaultIcon from '@material-ui/icons/ViewList';
import { useGetResourceLabel } from "ra-core";
import { useTranslation } from "react-i18next";
import BusinessIcon from '@material-ui/icons/Business';
import { Capability } from "reactAdmin/capabilities";

export const Menu = (props: MenuProps) => {
    const { t } = useTranslation();
    const { permissions: isAuthorized } = usePermissions();
    const { identity } = useGetIdentity();
    const resources = useSelector(getResources);
    const getResourceLabel = useGetResourceLabel();
    const {
        hasDashboard,
        dense,
    } = props;

    return (
        <RaMenu {...props}>
            {hasDashboard && <DashboardMenuItem dense={dense} />}
            {resources.filter(resource => resource.hasList && resource.name !== 'dasskdskdadas').map(resource => (

                <MenuItemLink
                    key={resource.name}
                    to={{
                        pathname: `/${resource.name}`,
                        state: { _scrollToTop: true },
                    }}
                    primaryText={getResourceLabel(resource.name, 2)}
                    leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                    dense={dense}
                />
            ))}
            {isAuthorized && isAuthorized(Capability.MANAGE_ORGANIZATION) && identity && identity.organizationId && (
                <MenuItemLink to={`/organizations/${identity.organizationId}`} primaryText={t('resource.organization')} leftIcon={<BusinessIcon />}/>
            )}
        </RaMenu>
    );
};